import template from "./individual-text-screen-preview.html";
import {individualTextScreenPreviewController} from "./individual-text-screen-preview.controller";
import "./individual-text-screen-preview.scss";

/**
 * Preview of the Individual Text screen on the device. Every element can be dragged;
 * the output picture is transcluded into its box. The fields show the text set in the cloud.
 */
export const individualTextScreenPreviewComponent = {
    template,
    controller: individualTextScreenPreviewController,
    controllerAs: "screenPreview",
    transclude: true,
    bindings: {
        settings: "<",
        screenWidth: "<",
        screenHeight: "<",
        index: "<"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/individual-text-screen-preview/individual-text-screen-preview.component.js